/**
 * Created by zhj on 3/18/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .service('pendingCommandService', function (crudService) {

    this.downloadRequest = function (downloadParams) {
      return crudService.post('pendingcommands', downloadParams);
    };

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/telephone/pendingCommandService.js